import type { FormGroup } from '@angular/forms';
import type { StepInputs } from '../interfaces';

export abstract class BaseForm {
  abstract stepsCtrls: { [K in keyof StepInputs]?: FormGroup };
}
